import { render, staticRenderFns } from "./Commits.vue?vue&type=template&id=1c046666&scoped=true&"
import script from "./Commits.vue?vue&type=script&lang=js&"
export * from "./Commits.vue?vue&type=script&lang=js&"
import style0 from "./Commits.vue?vue&type=style&index=0&id=1c046666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c046666",
  null
  
)

export default component.exports